<script>
	import { link } from "svelte-spa-router";
	import Radio from "./ui/Radio.svelte";
	import Checkbox from "./ui/Checkbox.svelte";
	import Button from "./ui/Button.svelte";

	import {
		supports,
		productsList,
		licenseCost,
		licenses,
		buyLink as directLink,
		customBuyLink,
	} from "./data";

	export let coupon = "";
	export let params;
	export let projects = "one";

	const license = licenses.find(a => a.id === "custom");

	const basePrice = [549, 2199];
	const supCost = { standard: [299, 299], priority: [898, 898] };
	let withCoreDiscount = [70, 35];
	let widgetsCountDiscount = 10;

	const lowCostProduct = [199, 399];
	const highCostProduct = [499, 999];
	const productCosts = {
		chat: highCostProduct,
		filemanager: lowCostProduct,
		kanban: highCostProduct,
		pivot: highCostProduct,
		scheduler: highCostProduct,
		spreadsheet: highCostProduct,
		query: lowCostProduct,
		usermanager: highCostProduct,
		gantt: highCostProduct,
		reportmanager: highCostProduct,
		diagram: highCostProduct,
		todolist: lowCostProduct,
		desktop: lowCostProduct,
	};

	const Logo = license.logo;
	let support = license.support;
	let devs = 2;

	let product = params ? params.product : null;
	let widgets = product ? { [product]: true } : {};
	let widgetsCore = { core: !product };

	if (product) widgets[product] = true;
	let hasWidgets, actualLicense, actualSupport, actualWidgets;
	$: {
		actualLicense = license;
		actualSupport = support;
		actualWidgets = widgets;
		if (projects === "unlimited") {
			actualLicense = licenses.find(a => a.id === "ultimate");
			actualSupport = "priority";
			actualWidgets = productsList.reduce(
				(obj, a) => (obj[a.id] = true) && obj,
				{}
			);
		}
		hasWidgets = Object.keys(actualWidgets).length;
	}

	const supportOptions = license.supportOptions.map((a, i) => ({
		id: supports[a].id,
		name: supports[a].name,
	}));
	const projectOptions = [
		{ id: "one", name: "One Project, up to 2 Developers" },
		{ id: "devteam", name: "Unlimited Projects, up to 5 Developers" },
		{ id: "unlimited", name: "Unlimited Projects and Developers" },
	];

	let fBatch = 0;
	$: fBatch = projects == "one" ? 0 : projects == "unlimited" ? 2 : 1;

	let total = 0;
	let price = 0;
	let discount = 0;
	let oldModels = {};
	$: {
		if (projects == "unlimited") {
			price = licenseCost.ultimate;
			oldModels.company = oldModels.devteam = oldModels.ultimate = Infinity;
		} else {
			let widgetsPrice = 0;
			let corePrice = widgetsCore.core ? basePrice[fBatch] : 0;
			for (var key in widgets) widgetsPrice += productCosts[key][fBatch];
			if (corePrice || widgetsPrice)
				total = corePrice + supCost[support][fBatch] + widgetsPrice;
			else total = 0;

			const baseTotal = total ? corePrice + supCost[support][fBatch] : 0;

			discount = 0;
			if (corePrice && hasWidgets)
				discount += (corePrice * withCoreDiscount[fBatch]) / 100;

			if (hasWidgets > 1)
				discount +=
					(Math.sqrt(hasWidgets) * widgetsPrice * widgetsCountDiscount) / 100;
			discount = Math.floor(discount);

			price = total - discount;
			if (baseTotal && price < baseTotal) {
				price = Math.floor(baseTotal + widgetsPrice / 3);
				discount = total - price;
			}

			oldModels.company = fBatch
				? Infinity
				: licenseCost.company + (supports === "priority" ? 599 : 0);
			oldModels.devteam =
				licenseCost.devteam + (support === "priority" ? 599 : 0);
			oldModels.ultimate = licenseCost.ultimate;
		}
	}

	function updateDevelopers(ev) {
		const projects = ev.detail.value;
		if (projects == "devteam") {
			devs = 5;
		} else if (projects == "one") {
			devs = 2;
		}
	}

	function s0(v) {
		return v ? "$" + v : "";
	}

	let buyLink;
	$: {
		if (projects == "unlimited")
			buyLink = directLink(
				licenses.find(a => a.id == "ultimate"),
				null,
				null,
				coupon
			);
		else
			buyLink = customBuyLink(widgetsCore.core, widgets, devs, support, coupon);
	}
</script>

<div class="container">
	<div class="main">
		<div class="icon">
			<div class="pricing-icon">
				<Logo />
			</div>
		</div>
		<div class="description">
			<div class="block">
				<h2>{actualLicense.name}</h2>
				{#if projects == 'unlimited'}
					<p class="warn">
						Only the
						<a href="/preview-pack/ultimate" use:link>Ultimate License</a>
						allows to have Unlimited Projects and Unlimited Developers
					</p>
				{/if}
				{#if price > oldModels.ultimate}
					<p class="warn">
						The
						<a href="/preview-pack/devteam" use:link>Ultimate License</a>
						looks like a better choise.
						<br />
						You will save
						<b>${price - licenseCost['ultimate']}</b>
					</p>
				{:else if price > oldModels.devteam}
					<p class="warn">
						The
						<a href="/preview-pack/devteam" use:link>DevTeam License</a>
						looks like a better choise.
						<br />
						It costs ${licenses.find(a => a.id === 'devteam').price} and
						includes ALL complex widgets
					</p>
				{:else if price > oldModels.company}
					<p class="warn">
						The
						<a href="/preview-pack/company" use:link>Company License</a>
						looks like a better choise.
						<br />
						It costs ${licenses.find(a => a.id === 'company').price} and
						includes ALL complex widgets
					</p>
				{/if}
				<ul class="info">
					<li>
						{#if projects == 'one'}One Project{:else}Unlimited Projects{/if}
					</li>
					<li>
						{#if projects == 'one'}
							Up to 2 Developers
						{:else if projects == 'devteam'}
							Up to 5 Developers
						{:else}Unlimited Developers{/if}
					</li>
					{#if projects != 'one'}
						<li>Can be used in SaaS products</li>
					{/if}
					<li>One year of updates and support</li>
					<li>Webix UI Library</li>
					<li>
						<a href="/legalnote/developer-license-agreement/" target="_blank">
							Perpetual Commercial License
						</a>
					</li>
				</ul>
			</div>

			{#if total}
				<div class="block">
					{#if actualSupport == 'basic'}
						<div>
							<h3>Basic Support:</h3>
							<ul>
								<li>Up to 72 hours initial response time</li>
								<li>10 tickets</li>
							</ul>
						</div>
					{:else}
						<div>
							<h3>
								Standard support:
								<span class="rprice">{s0(supCost.standard[fBatch])}</span>
							</h3>
							{#if actualSupport == 'standard'}
								<ul>
									<li>Up to 48 hours initial response time</li>
									<li>30 tickets / Unlimited 1st month</li>
								</ul>
							{/if}
						</div>
						{#if actualSupport == 'priority'}
							<div>
								<h3>
									Upgrade to Priority support:
									<span class="rprice">
										{s0(supCost.priority[fBatch] - supCost.standard[fBatch])}
									</span>
								</h3>
								<ul>
									<li>Up to 24 hours initial response time</li>
									<li>Unlimited tickets</li>
									<li>10 live chat sessions</li>
									<li>Emergency bug fixes</li>
									<li>Integration audit</li>
								</ul>
							</div>
						{/if}
					{/if}
				</div>

				{#if widgetsCore.core}
					<div class="block">
						<h3>
							Standard Widgets:
							<span class="rprice">{s0(basePrice[fBatch])}</span>
						</h3>
						<ul>
							<li>114 standard widgets</li>
						</ul>
					</div>
				{/if}

				{#if hasWidgets}
					<div class="block">
						<h3>Complex Widgets:</h3>
						<ul>
							{#each productsList as prod (prod.id)}
								{#if actualWidgets[prod.id]}
									<li>
										{prod.name}
										<span class="rprice">
											{s0(productCosts[prod.id][fBatch])}
										</span>
									</li>
								{/if}
							{/each}
						</ul>
					</div>
				{/if}

				{#if projects != 'unlimited'}
					<div class="sum">
						<span class="rprice">${total}</span>
					</div>
					<div class="block">
						{#if discount}
							<p>
								Discount:
								<span class="rprice discount">- ${discount}</span>
								<span class="rprice discount percent">
									{Math.round((discount * 100) / total)}% |
								</span>
							</p>
						{/if}
						{#if discount}
							<div class="sum">
								Final cost:
								<span class="rprice final">${price}</span>
							</div>
						{/if}
					</div>
				{/if}
			{/if}
		</div>
	</div>

	<div class="sidebar">

		<div class="total">
			<div class="row">
				<span class="title">Total:</span>
				<span class="price">${price}</span>
			</div>
			<div class="row">
				<span class="title">Coupon:</span>
				<input
					type="text"
					class="input"
					placeholder="Enter the coupon code"
					bind:value={coupon} />
			</div>
			<Button disabled={price == 0} href={buyLink} label="Add to Cart" />
		</div>

		<div class="block">
			<h3>Projects:</h3>
			<ul>
				<Radio
					options={projectOptions}
					bind:value={projects}
					on:change={updateDevelopers} />
			</ul>
		</div>

		{#if projects != 'unlimited'}
			<div class="block">
				<h3>Support Plan:</h3>
				<ul>
					<Radio options={supportOptions} bind:value={support} />
				</ul>
			</div>

			<div class="block">
				<h3>Standard Widgets:</h3>
				<ul>
					<Checkbox
						options={[{ name: '114 standard widgets', id: 'core' }]}
						bind:value={widgetsCore} />
				</ul>
			</div>

			<div class="block">
				<h3>Complex Widgets:</h3>
				<ul>
					<Checkbox options={productsList} bind:value={widgets} />
				</ul>
			</div>
		{/if}
	</div>
</div>

<style>
	.container {
		max-width: 111rem;
		padding: 2.5rem;
		margin: 0 auto;
		background-color: transparent;
		animation: fadeIn 0.4s 1 ease-in-out;
		animation-fill-mode: forwards;
		border: 1px solid #dedede;
		font-family: Roboto;
		font-style: normal;
		font-size: 16px;
		line-height: 25px;
		color: rgba(0, 0, 0, 0.7);
		box-sizing: border-box;

		display: flex;
	}
	.main {
		flex: 2;
		margin-top: 2rem;
	}
	.description {
		margin-left: 33.5%;
		padding-bottom: 2rem;
	}

	ul {
		font-size: 1.6rem;
		line-height: 3rem;
		color: rgba(0, 0, 0, 0.6);
	}

	.icon {
		float: left;
		width: 31.5%;
		min-width: 8rem;
		text-align: center;
	}
	.pricing-icon {
		display: inline-block;
		vertical-align: top;
		width: 65px;
	}

	h2 {
		font-size: 2rem;
		line-height: 3rem;
		font-weight: 500;
		text-transform: uppercase;
		margin-bottom: 1.5rem;
	}
	h2.sub {
		margin-top: 20px;
	}
	h3 {
		font-size: 1.6rem;
		line-height: 2.5rem;
		font-weight: 500;
		margin-bottom: 1rem;
	}

	.sidebar {
		flex: 1;

		margin-left: 1rem;
		padding: 2.5rem;
		background-color: #fff;
	}

	.block {
		margin-top: 3.3rem;
	}

	.block:first-child {
		margin-top: 0;
	}
	.total {
		margin-top: -1.5rem;
		padding-top: 1.5rem;
	}
	.title {
		font-size: 2rem;
		line-height: 3rem;
		color: rgba(0, 0, 0, 0.6);
		text-transform: uppercase;
		margin-right: 0.7rem;
		width: 84px;
	}
	.row {
		margin-top: 1.5rem;
		display: flex;
		align-items: center;
	}
	.price {
		font-size: 2rem;
		line-height: 3rem;
		text-transform: uppercase;
		color: rgba(0, 0, 0, 0.7);
		font-weight: 500;
	}
	.input {
		border: 1px solid #dedede;
		box-sizing: border-box;
		border-radius: 2px;
		padding: 7px 8px;
		flex-grow: 1;
		flex-shrink: 1;
		width: 100%;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 16px;
	}
	@media screen and (max-width: 820px) {
		.container {
			flex-wrap: wrap;
			max-width: 52rem;
		}
		.main,
		.sidebar {
			flex: initial;
			width: 100%;
		}
		.sidebar {
			padding: 0;
			margin: 0;
			background: transparent;
		}
		.icon {
			float: none;
			margin: 0 auto 2rem;
		}
		.description {
			margin-left: 0;
		}
		h2 {
			text-align: center;
			margin-bottom: 3.3rem;
		}
	}

	.rprice {
		float: right;
		padding-right: 50px;
		font-weight: 400;
	}
	.percent {
		padding-right: 10px;
		font-weight: 400;
	}
	.sum {
		border-top: 1px solid silver;
		margin-top: 10px;
		padding-top: 10px;
		height: 30px;
		clear: both;
	}
	.sum .rprice {
		font-weight: 500;
	}
	.warn {
		background: #f9dcfd;
		padding: 10px;
		border-radius: 3px;
		margin-bottom: 10px;
	}
	.discount {
		color: green;
	}

	.config h4 {
		font-size: 12px;
		margin: 6px 0 2px 0;
	}
	.config p {
		font-size: 12px;
	}
	.config input {
		padding: 3px;
	}
</style>
